import { useState } from 'react';
import Questions from './Questions';
import Levels from './Levels/Levels';
import File from './File/File';
import Layout from './File/Layout';
import ScoreDateBase from './ScoreDateBase';

const ProgramPrincipal = (props) => {
  const [loadingCount, setLoadingCount] = useState(0)
  const setLoading = (isLoading) => {
    setLoadingCount((prev) => Math.max(0, prev + (isLoading ? 1 : -1)));
  };
  const params = {
    message: props.message,
    logout: props.logout,
    setLoading
  }
  const isEditor = props.permissions.includes(18);
  const canEditScoreDateBase = props.permissions.includes(5);
  const canSeeProfile = props.permissions.includes(0);

  const fileUpdate = File({
    ...params,
    losesAccess: props.losesAccess
  })

  const layout = Layout({fileUrl: fileUpdate.fileUrl})

  const questions = Questions({
    ...params,
    losesAccess: props.losesAccess
  })

  const levels = Levels({
    ...params,
    losesAccess: props.losesAccess
  })

  const scoreDateBase = ScoreDateBase({
    ...params,
    losesAccess: props.losesAccess
  })

  const setProfilePoint = () => {
    props.setProfile('perfil');
  };

  return {
    ...questions,
    ...levels,
    ...scoreDateBase,
    ...fileUpdate,
    ...layout,
    loading: loadingCount > 0,
    isEditor,
    canEditScoreDateBase,
    canSeeProfile,
    setProfilePoint
  };
};

export default ProgramPrincipal;
